<div class="page-header">
  <div class="page-title" data-clarity-unmask="true">Serwer</div>
  <div class="page-subtitle">api.testy-na-prawko.net</div>
</div>

<div class="server-status">
  <div class="flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
    <div class="flex align-items-center gap-2">
      <h4 class="m-0">Obciążenie serwera</h4>
      @if (lastSampleUtc) {
        <span class="last-sample">
          ostatnia próbka: {{ lastSampleUtc | date: 'HH:mm:ss' }}
        </span>
      }
    </div>
    <div class="flex gap-2">
      @for (h of hoursOptions; track h) {
        <p-button
          [label]="h + 'h'"
          [outlined]="historyHours !== h"
          size="small"
          (onClick)="onHoursChange(h)"
          data-clarity-unmask="true"
        />
      }
    </div>
  </div>

  @for (group of summaryGroups; track group.serverName) {
    @if (summaryGroups.length > 1) {
      <div class="server-group-title">
        <i class="pi pi-server"></i>
        <span>{{ group.serverName }}</span>
        <span class="server-group-meta">
          ostatnia próbka: {{ group.lastSampleUtc | date: 'HH:mm:ss' }}
        </span>
      </div>
    }
    <div class="summary-grid">
      @for (card of group.cards; track card.label) {
        <div class="summary-card">
          <div class="summary-icon"><i [class]="card.icon"></i></div>
          <div class="summary-body">
            <div class="summary-label">{{ card.label }}</div>
            <div class="summary-value">{{ card.value }}</div>
            @if (card.detail) {
              <div class="summary-detail">{{ card.detail }}</div>
            }
          </div>
        </div>
      }
    </div>
  }

  @if (loading && !hasAnyChart) {
    <div class="flex justify-content-center py-5">
      <p-progressSpinner styleClass="w-3rem h-3rem" ariaLabel="loading" />
    </div>
  }

  @if (hasAnyChart) {
    <div class="charts">
      @if (cpuChartData) {
        <div class="chart-block">
          <div class="chart-title">Obciążenie procesorów [%]</div>
          <div class="chart-wrapper">
            <p-chart
              type="line"
              [data]="cpuChartData"
              [options]="percentChartOptions"
              height="260px"
            />
          </div>
        </div>
      }
      @if (ramChartData) {
        <div class="chart-block">
          <div class="chart-title">Zajętość pamięci RAM [%]</div>
          <div class="chart-wrapper">
            <p-chart
              type="line"
              [data]="ramChartData"
              [options]="percentChartOptions"
              height="260px"
            />
          </div>
        </div>
      }
      @if (diskChartData) {
        <div class="chart-block">
          <div class="chart-title">Zajętość dysku [%]</div>
          <div class="chart-wrapper">
            <p-chart
              type="line"
              [data]="diskChartData"
              [options]="percentChartOptions"
              height="260px"
            />
          </div>
        </div>
      }
      @if (networkChartData) {
        <div class="chart-block">
          <div class="chart-title">Ruch sieciowy [MB/s]</div>
          <div class="chart-wrapper">
            <p-chart
              type="line"
              [data]="networkChartData"
              [options]="networkChartOptions"
              height="260px"
            />
          </div>
        </div>
      }
    </div>
  } @else if (!loading) {
    <div class="empty-state">
      Brak próbek w wybranym zakresie. Serwer zbiera dane o obciążeniu co 30
      sekund — wykresy pojawią się po chwili od wdrożenia.
    </div>
  }
</div>
